import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludedSection } from '../components/IncludedSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ClosingCTASection } from '../components/ClosingCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen overflow-x-hidden bg-[#F9F5EF]" data-id="element-201">
      <HeroSection data-id="element-202" />
      <ProblemSection data-id="element-203" />
      <SolutionSection data-id="element-204" />
      <IncludedSection data-id="element-205" />
      <ForWhoSection data-id="element-206" />
      <HowItWorksSection data-id="element-207" />
      <ClosingCTASection data-id="element-208" />
      <Footer data-id="element-209" />
    </main>;
}